import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "./src/components/ErrorBoundary";
import Layout from "./src/components/Layout";
import { init as initAnalytics, trackPageview } from "./src/lib/analytics";
import { scrubPath } from "./src/lib/analytics/path-scrubber";
import "./src/lib/i18n";
import "./src/styles/global.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
  </ErrorBoundary>
);

export const wrapPageElement = ({
  element,
}: {
  element: React.ReactNode;
}) => <Layout>{element}</Layout>;

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  initAnalytics();
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (!location) return;
  const url = scrubPath(location.pathname) + (location.search ?? "");
  const title = typeof document !== "undefined" ? document.title : undefined;
  trackPageview(url, title);
};
